<div *ngIf="message && !toast" class="alert alert-info" role="alert">
  {{ message | translate }}
</div>
